export default class SubmitForm extends Phaser.State {
    preload() {
        this.game.stage.backgroundColor = '#7c0410';

        // Load the SDK asynchronously
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        FB.init({
            appId      : '169982493614709',
            cookie     : true,  // enable cookies to allow the server to access 
                                // the session
            xfbml      : true,  // parse social plugins on this page
            version    : 'v2.11' // use graph api version 2.8
        });
        FB.getLoginStatus((response)=> {
            this.statusChangeCallback(response);
        });
    
    }

    constructor(){
        super ();
        this.fbid = ''
        this.name = ''
    }

    create() {
        this._attachDOMEvents()
        // this.fbLogin()
        
    }
    fbLogin(){
        FB.login((response)=>{this.testAPI();this.fbid = response.authResponse.userID;},{scopes:'public_profile,email'});
    }
    statusChangeCallback(response) {
        // console.log('statusChangeCallback');
        if (response.status === 'connected') {
          // Logged into your app and Facebook.
          console.log('connected')
          this.testAPI();
          this.fbid = response.authResponse.userID;
          document.getElementById('fb-login').classList.remove('is-active')
          document.getElementById('submit-btn').classList.add('is-active')
        //   this._attachDOMEvents()
        } else {
            console.log('not connected')
            document.getElementById('fb-login').classList.add('is-active')
            document.getElementById('submit-btn').classList.remove('is-active')
            document.getElementById('fb-login').addEventListener('click', (e) => {
                FB.login((response)=>{
                    this.testAPI();
                    this.fbid = response.authResponse.userID;
                    document.getElementById('fb-login').classList.remove('is-active')
                    document.getElementById('submit-btn').classList.add('is-active')
                },{scopes:'public_profile,email'});
            })
            
          // The person is not logged into your app or we are unable to tell.
            
        }
    }
    testAPI() {
        FB.api('/me',{fields:'email,name'}, (response)=> {
            if(response != undefined || response != null){
                document.getElementById('ffsfullname').value = response.name;
                document.getElementById('ffsemail').value = response.email;
            }
        });
    }

    _attachDOMEvents(){
        this.game.paused = true;
        // Enable pre game selection modal buttons
        const gameSubmitModal = document.getElementById('game-submit-scores-modal');
        const submit = gameSubmitModal.querySelector('[data-submit-confirm]');
        submit.addEventListener('click', (e) => {
            this.checkvalidation();
        });

        // Activate game select modal
        gameSubmitModal.classList.add('is-active');
        this.game.paused = false;
    }
    checkvalidation(){
        const formname = document.getElementById('ffsfullname').value
        const formcontact = document.getElementById('ffscontactno').value
        const formemail = document.getElementById('ffsemail').value
        const formaddress1 = document.getElementById('ffsaddress_1').value
        const formaddress2 = document.getElementById('ffsaddress_2').value
        const formcheckbox = document.getElementById('ffsagree').checked

        if(this.fbid == ''){
            alert('Please sign in with Facebook.')
            this.fbLogin()
        }
        else if(formname == ""){
            alert('Please fill up your name.')
        }else if (formcontact == ""){
            alert('Please fill up your contact number.')
        }else if (!this.validateEmail(formemail)){
            alert('Please fill up your email.')``
        }else if (!formcheckbox){
            alert('Click agree the terms & conditions')
        }else{
            let url = `http://forefront.international/my/welcomepawsperity/API/leaderboards.php`
            // let data = new FormData([action='submit', fb_id=this.fbid,name=formname,email=formemail,contact_no=formcontact,address=formaddress1+formaddress2,scores=this.game.scores.toFixed(),game_time=this.game.gameTime,dogtype=this.game.dogType])

            let formData = new FormData()
            formData.append('action','submit')
            formData.append('fb_id',String(this.fbid))
            formData.append('name',String(formname))
            formData.append('email',String(formemail))
            formData.append('contact_no',String(formcontact))
            formData.append('address',String(formaddress1+formaddress2))
            formData.append('scores',String(this.game.scores.toFixed()))
            formData.append('game_time',String(this.game.gameTime))
            formData.append('dogtype',String(this.game.dogType))

            fetch(url, {
            method: 'post',
            body:formData
            })
            .then(res=>res.json())
            .then(res => {
                console.log(res)
                if(res.trx_status == "Success"){
                    console.log('Success post')
                    const gameSubmitModal = document.getElementById('game-submit-scores-modal');
                    this.game.gameName = formname;
                    this.state.start('LeaderBoard');
                    gameSubmitModal.classList.remove('is-active');
                }else if(res.trx_status == "Fail"){
                    alert('Fail to Submit the scores now.');
                }
            })
            .catch(err=>alert(err.message))

            

            // postAsForm(url,data)
        }
    }
    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
}



// WEBPACK FOOTER //
// ./js/states/submitform.js